// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"d6b409e5","455":"2f9fc06c","977":"1218d926"}[chunkId] + ".chunk.js";
};